import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { RemoteScreen } from './screens/RemoteScreen';
import { remoteMatchIdFromUrl } from './lib/handoff';
import { receiveRemoteControl } from './lib/remoteControl';
import { LocaleProvider } from './lib/i18n';
import { useScreenWakeLock } from './lib/useScreenWakeLock';
import './index.css';

const container = document.getElementById('root');
if (!container) throw new Error('#root not found');

/**
 * A remote is decided here rather than inside the app, and never unmounts back
 * into it. The app keeps its own idea of "the current match" in the address bar
 * and in storage, and a device that was handed one match as a remote must not
 * be able to fall through into a different one it happens to remember.
 */
const remoteMatchId = remoteMatchIdFromUrl();
if (remoteMatchId) receiveRemoteControl(remoteMatchId);

function RootScreen() {
  useScreenWakeLock();
  return remoteMatchId ? <RemoteScreen matchId={remoteMatchId} /> : <App />;
}

createRoot(container).render(
  <StrictMode>
    <LocaleProvider>
      <RootScreen />
    </LocaleProvider>
  </StrictMode>,
);
